import http from '../../../services/http-common';

class ExportOrderReplicateService {
    replicate(ID) {
    return http.get(`/ExportOrderReplicate/replicate/${ID}`);
    }
   
}

export default new ExportOrderReplicateService();